import { useRef } from 'react';
import { useRouter } from '@tanstack/react-router';

export interface PersonNavigation {
  selectUser: (userId: string) => void;
  /** Only a phone shows this way back; a link that opened on the person has no list behind it. */
  backToList: () => void;
}

/**
 * Moving from the list of people to one person's transcript and back.
 * `showPerson` puts the person in the URL, or takes them out with undefined.
 */
export function usePersonNavigation(
  showPerson: (userId: string | undefined) => void,
  forgetConversation: () => void,
): PersonNavigation {
  const router = useRouter();
  /* Whether the person was picked on this page, so the way back is one step back. */
  const pickedHere = useRef(false);

  function selectUser(id: string) {
    /* The conversation belonged to the person being left behind. */
    forgetConversation();
    pickedHere.current = true;
    showPerson(id);
  }

  function backToList() {
    if (pickedHere.current) {
      router.history.back();
      return;
    }

    forgetConversation();
    showPerson(undefined);
  }

  return { selectUser, backToList };
}
